<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col cols="12" v-if="item">
          <router-link v-if="item && prevRoute && prevRoute.name === 'EXCMDeviceShow'" :to="{ name: 'EXCMDeviceShow', params: { id: retrieved['@id'] }}" class="btn btn-default float-right">{{ $t('buttons.backToShow') }}</router-link>
          <router-link v-else :to="{ name: 'EXCMDeviceList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
        <b-col cols="12">
          <b-card>
            <b-card-title>{{$t('views.excmdevice.update.title')}}  {{ item && item['serialNumber'] }}</b-card-title>
            <EXCMDeviceForm
                    v-if="item"
                    :handle-submit="onSendForm"
                    :handle-update-field="updateField"
                    :values="item"
                    :errors="violations"
                    :initial-values="retrieved" />
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMDeviceForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMDeviceForm,
    Loader
  },

  data () {
    return {
      item: {},
      prevRoute: null
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmdevice/update/isLoading',
      error: 'excmdevice/update/error',
      deleteError: 'excmdevice/del/error',
      deleteLoading: 'excmdevice/del/isLoading',
      created: 'excmdevice/create/created',
      deleted: 'excmdevice/del/deleted',
      retrieved: 'excmdevice/update/retrieved',
      updated: 'excmdevice/update/updated',
      violations: 'excmdevice/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMDeviceList' })
    },
    updated: function (updated) {
      this.$Swal({
        title: updated.serialNumber + ' ' + this.$t('notifications.updated'),
        type: 'success',
        showConfirmButton: false,
        timer: 1500
      })
      this.$router.push({ name: 'EXCMDeviceShow', params: { id: updated['@id'] } })
    }
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  beforeCreate () {
    checkPagePermission('devices', 'EXCMDeviceUpdate')
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmdevice/create/reset',
      deleteItem: 'excmdevice/del/del',
      delReset: 'excmdevice/del/reset',
      retrieve: 'excmdevice/update/retrieve',
      updateReset: 'excmdevice/update/reset',
      update: 'excmdevice/update/update',
      updateRetrieved: 'excmdevice/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmdevice ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
